import { UserStatus } from "@validereinc/domain";
import { toTitleCaseString } from "@validereinc/utilities";
import { convertMapToOpts } from "../shared/index.ts";

export const UserStatusOptions = convertMapToOpts(UserStatus, ([_, value]) =>
  toTitleCaseString(value)
);
